/* eslint-disable import/no-unresolved */
import React from 'react';

import yourroleSVG from 'assets/resources/pages/how-we-do/yourrole_icon.svg';
import ourroleSVG from 'assets/resources/pages/how-we-do/ourrole_icon.svg';
import outcomeSVG from 'assets/resources/pages/how-we-do/outcome_icon.svg';
import durationSVG from 'assets/resources/pages/how-we-do/duration_icon.svg';
import ImgHTML from '../../../ImgHTML';

const Icons = ({
  yourRoleDetails,
  outcomeDetails,
  ourRoleDetails,
  durationDetails
}) => {
  return (
    <div className="icons">
      <div className="row">
        <div className="col-md-6">
          <div className="item">
            <ImgHTML src={yourroleSVG} alt="yourrole icon" />
            <div className="body">
              <strong>Your Role</strong>
              <div className="dd">{yourRoleDetails}</div>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="item">
            <ImgHTML src={outcomeSVG} alt="outcome icon" />
            <div className="body">
              <strong>Outcome</strong>
              <div className="dd">{outcomeDetails}</div>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="item">
            <ImgHTML src={ourroleSVG} alt="ourrole icon" />
            <div className="body">
              <strong>Our role</strong>
              <div className="dd">{ourRoleDetails}</div>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="item">
            <ImgHTML src={durationSVG} alt="duration icon" />
            <div className="body">
              <strong>Duration</strong>
              <div className="dd">{durationDetails}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Icons;
